module.exports = __webpack_public_path__ + "img/lg_cngc.b5249d82.png";